import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - data stays fresh
      gcTime: 30 * 60 * 1000, // 30 minutes - garbage collection
      retry: 1, // Retry once on failure
      refetchOnWindowFocus: false, // Don't refetch on tab focus
    },
    mutations: {
      retry: false, // Don't retry mutations
    },
  },
});
